import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #dfebff;
	padding: 50px 50px 0;
	margin-top: 20px;
	box-shadow: 0 1px 1px #dfdfdf;
	overflow: hidden;
	.img {
		flex: 0 1 500px;
		img {
			margin-bottom: -27px;
		}
	}
	.about-text {
		flex: 0 1 600px;

		h2 {
			margin-bottom: 14px;
		}
		p {
			font-size: 20px;
			line-height: 35px;
			color: var(--tab-link-color-hover);
		}
	}
	@media only screen and (max-width: 767px) {
		padding: 20px 20px 0;
		.container {
			flex-direction: column-reverse;

			& > div {
				margin: 0 auto 0;
				flex: 0 1 auto;
			}
		}
	}
`;
